import React from 'react';
import Fade from 'react-reveal/Fade';

import { WhatWeDoWrapper } from './whatWeDo.styled';
import Container from '../container/container.component';

interface Props {
	className?: string;
}

const WhatWeDo = (props: Props) => {
	const { className } = props;
	return (
		<WhatWeDoWrapper className={className ? className : ''}>
			<Container>
				<Fade top cascade>
					<div className="content">
						<div className="left-section">
							<p className="title">
								Our mission is to accelerate advancement by reinventing business
								as we know it using the power of technology.
							</p>
						</div>
						<div className="right-section">
							<p className="sub-title">
								At the core of this collaboration is a commitment to nurture and
								amplify local and regional success stories.
							</p>
						</div>
					</div>
				</Fade>
			</Container>
		</WhatWeDoWrapper>
	);
};

export default WhatWeDo;
